import { IconCheckDefault } from '@iwoca/icons';
import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';

export const StepIndicator = ({
    children,
    className
}: {
    children: React.ReactNode;
    className?: string;
}) => (
    <div
        className={twMerge(
            classNames(
                'relative z-0 flex w-full items-center justify-evenly py-s',
                className
            )
        )}
        data-testid="step-indicator"
    >
        {children}
        <Separator />
    </div>
);

export const Step = ({
    isComplete = false,
    isActive = false,
    children
}: {
    isComplete?: boolean;
    isActive?: boolean;
    children?: React.ReactNode;
}) => (
    <div className="flex w-full flex-row items-center justify-evenly">
        <Separator className={isActive || isComplete ? 'bg-primary-20' : ''} />
        <div className="flex flex-col items-center justify-center text-structure-40">
            <div
                className={twMerge(
                    classNames(
                        'relative flex size-[30px] flex-col items-center justify-center rounded-full border-4 border-solid border-secondary-80 bg-transparent',
                        {
                            'border-4 border-solid border-primary-20 bg-primary-20':
                                isActive || isComplete
                        },
                        {
                            'border-3 size-[30px] border-solid': isActive
                        }
                    )
                )}
                data-testid="step-indicator-step"
            >
                {isComplete && (
                    <IconCheckDefault
                        className="z-[1] size-[30px] rounded-full [&_path]:fill-structure-100"
                        aria-hidden
                    />
                )}

                {children}
            </div>
        </div>
    </div>
);

export const StepLabel = ({ children }: { children: React.ReactNode }) => (
    <div className="absolute top-full pt-s text-center text-xs min-l:text-m min-l:font-med">
        {children}
    </div>
);

const Separator = ({ className }: { className?: string }) => (
    <div
        className={twMerge(
            classNames('relative z-[-1] h-xs w-full bg-secondary-80', className)
        )}
    />
);
